import { render } from "./FpTree.vue?vue&type=template&id=c0864c2e"
import script from "./FpTree.vue?vue&type=script&lang=js"
export * from "./FpTree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__